import { STAGE } from "../constant/globalEnv.constant";

export const atLeastOneUpperLowerNumberSpecialCharRegex = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,64}$";
export const emailRegexAllowPlus = /^[a-zA-Z0-9.+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const emailRegexNotAllowPlus = /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const validLinkRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/\S*)?$/;
// Dev: allow +
export const emailRegex = ["dev", "local"].includes(STAGE)
  ? emailRegexAllowPlus
  : // Prod: disallow +
    emailRegexNotAllowPlus;

export const FULL_NAME_REGEX = /^([a-zA-Z@&._\s-']+)*$/;
export const OTHER_NAME_REGEX = /^([a-zA-Z0-9@&._\s-,']+)*$/;

export const NO_SPECIAL_CHAR_REGEX = "^[a-zA-Z0-9]+$";

export const validateName = (fieldName: string) => (value: string) => {
  const trimmedValue = value.trim();
  const capitalizedFieldName = fieldName.charAt(0).toLocaleLowerCase() + fieldName.slice(1);
  const message = `Enter a valid ${capitalizedFieldName}.`;

  // Regular expression for valid name characters
  const nameRegex = /^[a-zA-Z\s@&._-]+$/;

  if (!nameRegex.test(trimmedValue)) {
    return message;
  }
  return true;
};

export const validateTrim = (value: string): true | string => {
  return value.trim() === value || "Spaces are not allowed";
};

export const publicDomain = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "outlook.com",
  "icloud.com",
  "mail.com",
  "zoho.com",
  "yandex.com",
  "gmx.com",
  "live.com",
  "msn.com",
  "inbox.com",
  "fastmail.com",
  "me.com",
  "mail.ru",
  "rediffmail.com",
];
interface FormatLengthyNameProps {
  initialLength?: number;
}

export const formatLengthyName = (fileName: string, { initialLength = 20 }: FormatLengthyNameProps = {}) => {
  if (!fileName) return fileName;
  const parts = fileName.split(".");
  const extension = parts.pop() || "";
  const nameWithoutExt = parts.join(".");

  if (nameWithoutExt.length > initialLength) {
    return `${nameWithoutExt.slice(0, initialLength)}...${nameWithoutExt.slice(-1)}.${extension}`;
  }

  return fileName;
};

interface MaskOptions {
  isEmail?: boolean;
  startDigits?: number;
  endDigits?: number;
  maxStars?: number;
}

export const maskString = (input: string, options?: MaskOptions): string => {
  if (!input) return "";

  const { isEmail = false, startDigits = 5, endDigits = 4, maxStars = 4 } = options || {};
  // email
  if (isEmail && input.includes("@")) {
    const [local, domain] = input.split("@");
    const visibleStart = Math.min(startDigits, Math.ceil(local.length / 2));
    return `${local.slice(0, visibleStart)}${"*".repeat(Math.min(maxStars, local.length - visibleStart))}@${domain}`;
  }
  // default
  const halfLength = Math.floor(input.length / 2);
  const start = startDigits ?? halfLength;
  const end = endDigits ?? halfLength;

  const totalVisible = Math.min(start + end, input.length);
  const adjustedStart = Math.max(start, totalVisible / 2);
  const adjustedEnd = Math.min(end, totalVisible / 2);

  return `${input.slice(0, adjustedStart)}${"*".repeat(Math.min(maxStars, input.length - adjustedStart - adjustedEnd))}${input.slice(-adjustedEnd)}`;
};

export const filterTruthyValues = <T extends Record<string, any>>(obj: T): Partial<T> => {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => Boolean(value))) as Partial<T>;
};

export const generateAcronym = (name: string) => {
  if (!name) return "";
  // Remove any non-alphabet characters from the name
  const cleanName = name.replace(/[^a-zA-Z\s]/g, "");
  // Split the name into words
  const splitText = cleanName.split(" ");
  // Create acronym by taking the first letter of each word
  const acronym = splitText
    .map((word) => word.charAt(0).toUpperCase())
    .join("")
    .slice(0, 2);

  return acronym;
};
export const getValidUrl = (url?: string) => {
  if (!url) return undefined;
  return /^(https?:)?\/\//.test(url) ? url : `https://${url}`;
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case "Active":
      return "!bg-greenStatus-bg !text-greenStatus-text px-3 py-1";
    case "Ex-employee":
      return "!bg-text-errorBg !text-text-error px-3 py-1";
    default:
      return "!bg-gray-100 !text-gray-800 px-3 py-1";
  }
};

export const formateCurrency = (value: string) => {
  const formattedValue: any = value?.replace(/\D/g, "");
  return new Intl.NumberFormat().format(formattedValue);
};
